import { useMemo } from 'react';

import { type GasPurePayload, type GasPureScreenEventPayload } from '@atlaskit/analytics-gas-types';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import {
	OPERATIONAL_EVENT_TYPE,
	SCREEN_EVENT_TYPE,
	TRACK_EVENT_TYPE,
	UI_EVENT_TYPE,
} from '@atlassian/analytics-bridge';

import { ANALYTICS_CHANNEL } from '../../../common/constants';

type AnalyticsType =
	| typeof TRACK_EVENT_TYPE
	| typeof OPERATIONAL_EVENT_TYPE
	| typeof UI_EVENT_TYPE
	| typeof SCREEN_EVENT_TYPE;

export const useAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useMemo(() => {
		const fireAnalytics = (
			eventPayload: GasPurePayload | GasPureScreenEventPayload,
			analyticsType: AnalyticsType,
		) => {
			createAnalyticsEvent({
				analyticsType,
				...eventPayload,
			}).fire(ANALYTICS_CHANNEL);
		};

		return {
			fireUIEvent: (event: GasPurePayload) => fireAnalytics(event, UI_EVENT_TYPE),
			fireOperationalEvent: (event: GasPurePayload) => fireAnalytics(event, OPERATIONAL_EVENT_TYPE),
			fireTrackEvent: (event: GasPurePayload) => fireAnalytics(event, TRACK_EVENT_TYPE),
			fireScreenEvent: (event: GasPureScreenEventPayload) =>
				fireAnalytics(event, SCREEN_EVENT_TYPE),
		};
	}, [createAnalyticsEvent]);
};
